import { http } from './client';

/** 本体树节点类型 */
export type OntologyNodeType = 'DIRECTORY' | 'ONTOLOGY';

/** 本体树节点（接口返回的原始结构） */
export interface OntologyNode {
  /** 节点 id（目录 id 或关联记录 id） */
  id: number;
  /** 节点名称 */
  name: string;
  /** 节点类型：目录或本体 */
  type: OntologyNodeType;
  /** 层级（后端给定） */
  level: number;
  /** 本体真实 id，只有 type=ONTOLOGY 才会有 */
  ontologyId?: number;
  /** 权限字段 */
  canView?: boolean;
  canEdit?: boolean;
  canManage?: boolean;
  /** 子节点 */
  children?: OntologyNode[];
}

/** 知识库（dataset）条目 */
export interface KnowledgeBaseItem {
  id: string;
  name: string;
  description?: string;
  provider?: string;
  permission?: string;
  read_permission?: string;
  edit_permission?: string;
  data_source_type?: string | null;
  indexing_technique?: string | null;
  app_count?: number;
  document_count?: number;
  word_count?: number;
  created_at?: number;
  updated_at?: number;
  embedding_model?: string | null;
  embedding_model_provider?: string | null;
  embedding_available?: boolean;
  tags?: unknown[];
  doc_form?: string | null;
  /** 其它字段保留弹性 */
  [key: string]: unknown;
}

/**
 * 获取本体树
 * GET /ai-api/holon/v1/data/ontologies
 */
export async function getOntologyTree(): Promise<OntologyNode[]> {
  const response = await http.get<OntologyNode[]>(
    '/ai-api/holon/v1/data/ontologies'
  );

  return response.data || [];
}

/**
 * 获取知识库列表
 * GET /ai-api/holon/v1/data/datasets
 */
export async function getKnowledgeBaseList(): Promise<KnowledgeBaseItem[]> {
  const response = await http.get<KnowledgeBaseItem[]>(
    '/ai-api/holon/v1/data/datasets'
  );

  return response.data || [];
}
